import React from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

/**
 * @param {string} props.selectedProject - Stores index of user's selected project  
 * @returns component with a button that navigates to build_apps page
 */
const DesignView = (props) => {
  const { selectedProject } = props;

  const navigate = useNavigate();

  const changeToBuildApps = () => {
    navigate('/build_apps', {
      state: {
        name: JSON.parse(localStorage.getItem('data'))[selectedProject].name,
        reason: 'backToBuildApps'
      }
    });
  };

  // Button that navigates to build_apps page
  return (
      <div
        data-tooltip=" Design View"
        data-tooltip-pos="bottom"
        className={clsx('fas', 'fa-pencil-ruler', 'teamSelector')}
        onClick={changeToBuildApps}
        style={{ marginRight: '1vw', marginTop: '0.5vw' }}
        aria-hidden="true"
      />
  );
};

export default DesignView;
